document.addEventListener("DOMContentLoaded", function () {
  // 初始化所有 Swiper 实例，但延迟隐藏的那些在可见时刷新
  const swipers = [];

  document
    .querySelectorAll(".collection-wrapper .swiper")
    .forEach((swiperEl) => {
      const swiper = new Swiper(swiperEl, {
        slidesPerView: 4,
        spaceBetween: 26,
        freeMode: true,
        navigation: {
          nextEl: swiperEl.querySelector(".swiper-button-next"),
          prevEl: swiperEl.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: swiperEl.querySelector(".swiper-pagination"),
          type: "progressbar", // 启用进度条
        },
        breakpoints: {
          1200: {
            //当屏幕宽度小于等于1200
            slidesPerView: 3,
            spaceBetween: 14,
          },
          768: {
            //当屏幕宽度小于等于768
            slidesPerView: 2,
            spaceBetween: 8,
          },
        },
      });
      // 让进度条可点击
      const progressEl = swiperEl.querySelector(".swiper-pagination");
      progressEl.addEventListener("click", (e) => {
        const rect = progressEl.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const progress = clickX / rect.width; // 点击位置比例
        const newIndex = Math.floor(progress * swiper.slides.length); // 计算对应 slide
        swiper.slideTo(newIndex);
      });
      swipers.push({ el: swiperEl, instance: swiper });
    });

  // nav-item 点击切换
  const navItems = document.querySelectorAll(
    ".common-featured-collections .nav-item"
  );
  const collections = document.querySelectorAll(
    ".common-featured-collections .collection-wrapper"
  );

  function activateCollection(index) {
    if (index < 0) index = navItems.length - 1;
    if (index >= navItems.length) index = 0;

    navItems.forEach((i) => i.classList.remove("active"));
    collections.forEach((c) => c.classList.remove("active"));

    const activeItem = navItems[index];
    const targetCollection = activeItem.getAttribute("data-collection");
    const target = document.querySelector(
      `.collection-wrapper[data-collection="${targetCollection}"]`
    );

    activeItem.classList.add("active");
    if (target) {
      target.classList.add("active");
      const swiperData = swipers.find(
        (s) => s.el === target.querySelector(".swiper")
      );
      if (swiperData) swiperData.instance.update();
    }

    // 让当前 active item 滚动到左边
    activeItem.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start", // 靠左对齐
    });
  }

  navItems.forEach((item, idx) => {
    item.addEventListener("click", () => {
      activateCollection(idx);
      updateDisableClass();
    });
  });

  const prevBtn = document.querySelector(
    ".common-featured-collections .nav-btn .icon-swiper-prev"
  );
  const nextBtn = document.querySelector(
    ".common-featured-collections .nav-btn .icon-swiper-next"
  );

  function getActiveIndex() {
    return Array.from(navItems).findIndex((i) =>
      i.classList.contains("active")
    );
  }

  prevBtn?.addEventListener("click", () => {
    const current = getActiveIndex();
    if (current != 0) {
      prevBtn.classList.remove("disable");
      activateCollection(current - 1);
    }
    updateDisableClass();
  });

  nextBtn?.addEventListener("click", () => {
    const current = getActiveIndex();
    if (current != navItems.length - 1) {
      nextBtn.classList.remove("disable");
      activateCollection(current + 1);
    }
    updateDisableClass();
  });

  // 统一控制按钮状态
  function updateDisableClass() {
    const current = getActiveIndex();

    if (current <= 0) {
      prevBtn.classList.add("disable");
    } else {
      prevBtn.classList.remove("disable");
    }

    if (current >= navItems.length - 1) {
      nextBtn.classList.add("disable");
    } else {
      nextBtn.classList.remove("disable");
    }
  }
  updateDisableClass();


    // ===== 统一所有 swiper-wrapper 高度 =====
  // function setUniformSwiperHeights() {
  //   const wrappers = document.querySelectorAll(".common-featured-collections .collection-wrapper .swiper-wrapper");
  //   if (!wrappers.length) return;

  //   // 先重置高度，避免重复计算叠加
  //   wrappers.forEach(wrapper => wrapper.style.height = "auto");

  //   // 获取最高高度
  //   let maxHeight = 0;
  //   wrappers.forEach(wrapper => {
  //     const h = wrapper.scrollHeight;
  //     if (h > maxHeight) maxHeight = h;
  //   });

  //   // 应用到所有 wrapper
  //   wrappers.forEach(wrapper => {
  //     wrapper.style.height = `${maxHeight}px`;
  //   });
  // }

  // // 图片加载完后再计算，避免初始高度不准
  // window.addEventListener("load", setUniformSwiperHeights);
  // // 监听窗口变化，响应式重算
  // window.addEventListener("resize", setUniformSwiperHeights);



});
